import { CAL_DESKTOP_ELEMENT_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: CAL_DESKTOP_ELEMENT_MNG,
  params: null,
  view: {
    title: '创建桌面元素',
    labelPosition: 'right',
    content: [
      {
        $id: 'name',
        $type: 'input',
        label: '名称',
        $el: {
          placeholder: '请输入名称',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: '名称'
          }
        ]
      },
      {
        $id: 'industryId',
        $type: 'select',
        label: '行业',
        $options: [],
        rules: [
          {
            notEmpty: '行业不能为空'
          }
        ]
      },
      {
        $id: 'type',
        $type: 'select',
        label: '桌面元素类型',
        $el: {
          placeholder: '请输入桌面元素类型',
          suffixIcon: 'el-icon-edit',
          filterable: true
        },
        $options: [
          {
            label: '软件',
            value: 'SOFTWARE'
          },
          {
            label: '高主频',
            value: 'HIGH_CPU_SPEED'
          },
          {
            label: '场景默认配置',
            value: 'SCENE_CONFIG'
          }
        ],
        rules: [
          {
            notEmpty: 'type'
          }
        ]
      },
      {
        $id: 'softVersion',
        $type: 'input',
        label: '软件版本',
        $el: {
          placeholder: '请输入软件版本',
          suffixIcon: 'el-icon-edit'
        }
      },
      {
        $id: 'workScene',
        $type: 'input',
        label: '工作场景',
        $el: {
          placeholder: '请输入工作场景',
          suffixIcon: 'el-icon-edit'
        }
      },
      {
        $id: 'materialMin',
        $type: 'input-number',
        label: '素材最小值(MB)',
        $el: {
          placeholder: '请输入素材最小值',
          suffixIcon: 'el-icon-edit',
          min: 0,
          value: null
        }
      },
      {
        $id: 'materialMax',
        $type: 'input-number',
        label: '素材最大值(MB)',
        $el: {
          placeholder: '请输入素材最大值',
          suffixIcon: 'el-icon-edit',
          min: 0,
          value: null
        }
      },
      {
        $id: 'cpuSpeed',
        $type: 'input-number',
        label: 'cpu主频(GHZ)',
        $default: 2.8,
        $el: {
          placeholder: '请输入cpu主频',
          suffixIcon: 'el-icon-edit',
          precision: '2',
          step: '0.1',
          min: 0
        }
      },
      {
        $id: 'cpuCore',
        $type: 'input-number',
        label: 'cpu核数',
        $default: 4,
        $el: {
          placeholder: '请输入cpu核数',
          suffixIcon: 'el-icon-edit',
          min: 0
        }
      },
      {
        $id: 'memory',
        $type: 'input-number',
        label: '内存大小(G)',
        $default: 8,
        $el: {
          placeholder: '请输入内存大小',
          suffixIcon: 'el-icon-edit',
          min: 0
        }
      },
      {
        $id: 'videoMemory',
        $type: 'input-number',
        label: '显存大小(G)',
        $default: 1,
        $el: {
          placeholder: '请输入显存大小',
          suffixIcon: 'el-icon-edit',
          precision: '2',
          min: 0
        }
      },
      {
        $id: 'iops',
        $type: 'input-number',
        label: 'iops大小',
        $el: {
          placeholder: '请输入iops大小',
          suffixIcon: 'el-icon-edit',
          min: 0
        }
      },
      {
        $id: 'systemDiskSize',
        $type: 'input-number',
        label: '系统盘大小(G)',
        $el: {
          placeholder: '请输入系统盘大小',
          suffixIcon: 'el-icon-edit',
          min: 0
        }
      },
      {
        $id: 'dataDiskSize',
        $type: 'input-number',
        label: '数据盘大小(G)',
        $el: {
          placeholder: '请输入数据盘大小',
          suffixIcon: 'el-icon-edit',
          min: 0
        }
      }
    ]
  }
}
